import { Component, OnInit } from '@angular/core';
import { DataExchangeService, DataSet } from './data-exchange.service';

/**
 * Settings > Data Export (administrators only; replaces twin-ci Database Export). Choose a data set,
 * its fields and an optional date range; the CSV downloads straight to the browser with readable
 * values. Nothing is stored on the server.
 */
@Component({
    selector: 'app-data-export',
    templateUrl: './data-export.component.html',
    styleUrls: ['./data-exchange.component.scss']
})
export class DataExportComponent implements OnInit {
    dataSets: DataSet[] = [];
    set: DataSet = null;
    chosen: { [key: string]: boolean } = {};
    from = '';
    to = '';
    loaded = false;
    exporting = false;
    error = '';
    message = '';

    constructor(private api: DataExchangeService) { }

    ngOnInit() {
        this.api.catalog().subscribe(
            res => {
                this.dataSets = res.data_sets || [];
                this.loaded = true;
                if (this.dataSets.length) {
                    this.pick(this.dataSets[0]);
                }
            },
            err => this.error = typeof err === 'string' ? err : 'Data sets could not be loaded.'
        );
    }

    pick(set: DataSet) {
        this.set = set;
        this.chosen = {};
        set.fields.forEach(f => this.chosen[f.key] = true);
        this.message = '';
        this.error = '';
    }

    get chosenCount(): number {
        return this.set ? this.set.fields.filter(f => this.chosen[f.key]).length : 0;
    }

    selectAll(on: boolean) {
        this.set.fields.forEach(f => this.chosen[f.key] = on);
    }

    download() {
        this.error = '';
        this.message = '';
        if (!this.chosenCount) {
            this.error = 'Choose at least one field to export.';
            return;
        }
        if (this.from && this.to && this.from > this.to) {
            this.error = 'The end date must be on or after the start date.';
            return;
        }
        const fields = this.set.fields.filter(f => this.chosen[f.key]).map(f => f.key);
        this.exporting = true;
        this.api.export(this.set.key, fields, this.from, this.to).subscribe(
            res => {
                this.exporting = false;
                const header = res.headers.get('Content-Disposition') || '';
                const match = /filename="?([^"]+)"?/.exec(header);
                this.api.save(res.body, match ? match[1] : this.set.key + '.csv');
                this.message = this.set.label + ' exported.';
            },
            () => {
                this.exporting = false;
                this.error = 'The export could not be created. Please try again.';
            }
        );
    }
}
